// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ConsentModal from './components/ConsentModal.js';
import Layout from './components/Layout.jsx';
import './styles.css';
import './newPages.css';
import { logInteraction } from './utils/tracker.js';

// ---- SYNC imports ----
import LandingPage from './pages/landingpage.js';
import HomePage from './pages/homepage.js';
import GenrePage from './pages/genrepage.js';
import CategoriesPage from './pages/categoriespage.js';
import ContactPage from './pages/contactpage.js';
import AboutPage from './pages/aboutpage.js';
import BookPage from './pages/bookpage.js';
import SearchPage from './pages/searchpage.js';
import NotFoundPage from './pages/notfoundpage.js';
import PrivacyPolicy from './pages/privacy-policy.js';
import Impressum from './pages/Impressum.js';
import AuthorPage from './pages/AuthorPage.js';
import ServicesPage from './pages/servicespage.js';
import PublishingPage from './pages/publishingpage.js';

const S3_BUCKET_URL = process.env.REACT_APP_S3_BUCKET_URL;

// Analytics must never block navigation
const PageTrackerWrapper = () => {
  const location = useLocation();

  useEffect(() => {
    const t = setTimeout(() => {
      try {
        logInteraction('page_view', { page: location.pathname + location.search });
      } catch {}
    }, 300);

    return () => clearTimeout(t);
  }, [location]);

  return null;
};

export default function App() {
  return (
    <HelmetProvider>
      <Router basename="/">
        <ConsentModal />
        <PageTrackerWrapper />

        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<LandingPage />} />

            <Route path="/library" element={<HomePage />} />
            <Route path="/genre/:genreSlug" element={<GenrePage bucketUrl={S3_BUCKET_URL} />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/publishing" element={<PublishingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/book/:titleSlug" element={<BookPage bucketUrl={S3_BUCKET_URL} />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/author/:authorSlug" element={<AuthorPage />} />

            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  );
}